let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("jwi3q")).then(() => parcelRequire('kLNrh'));